import React from 'react'
import IconButtonUI from '../../../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../../../widgets/layout/LRTableActionsUI.js'
import SuperUserSettingsPageUI from '../../../../../templates/SuperUserSettingsPageUI.js'
import MasterTemplateNavUI from '../../../../../components/superUser/settings/masterTemplates/MasterTemplateNavUI.js'
import TermSheetScheduleRowsSF from '../../../../../components/superUser/loan/TermSheetScheduleRowsSF.js'

const MasterTermSheetSchedulePageUI = ({ context, page, title, scheduleRowList, onRefreshClick }) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_props' topnav='settings'
    headerText='Master Template Terms' page='ftlTemplate' dimension='w1600'
  >
    <div>
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Master Template Terms</b></span>
          </span>
        }
        right={<span />}
      />

      <MasterTemplateNavUI activeTab='termSheet' />

      <div className='g_m_top_100' />
      <TermSheetScheduleRowsSF
        context={context}
        loan={{ loanId: 'master' }}
        title={title}
        scheduleRowList={scheduleRowList}
        onRefreshClick={onRefreshClick}
      />
    </div>
  </SuperUserSettingsPageUI>

export default MasterTermSheetSchedulePageUI
